import { useGetOrdersSummary } from 'api/orders/use-get-orders-summary.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { useRoleGuard } from 'shared/hooks/use-role-guard';
import { useOrderFiltersStore } from 'shared/stores/use-order-filters.ts';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ListSummary } from 'components/common/list-summary';

const OrdersSummaryComponent = () => {
  const { filters, search } = useOrderFiltersStore();
  const { data, isLoading } = useGetOrdersSummary({ search, filters });

  const isAllowProfitByMap = useRoleGuard([UserRole.admin]);

  return (
    <ListSummary isLoading={isLoading}>
      <div>
        Count: {numberFormatter(data?.count || 0)}
        {' / '}
        Freight: {numberFormatter(data?.totalFreight || 0)}€{' / '}
        Total document price: {numberFormatter(data?.totalDocumentPrice || 0)}€{' / '}
        Total fine: {numberFormatter(data?.totalFine ?? 0)}€
      </div>
      <div>
        Costs: {numberFormatter(data?.totalCost || 0)}€{' / '}
        Add costs: {numberFormatter(data?.totalAdditionalCost || 0)}€{' / '}
        Without cost: {numberFormatter(data?.countWithoutCost ?? 0)}
        {' / '}
        <strong>Profit: {numberFormatter(data?.totalProfit || 0)}€</strong>
        {isAllowProfitByMap && (
          <>
            {' / '}
            <strong>Profit by map: {numberFormatter(data?.totalProfitByMap || 0)}€</strong>
          </>
        )}
      </div>
    </ListSummary>
  );
};

export const OrdersSummary = withRoleGuard(OrdersSummaryComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
